/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig = {
    auth: {
        clientId: "ae090dec-6b9f-417a-9d9a-cc6dc2d7ed4b",
        authority: "https://login.microsoftonline.com/5fb9c328-f87e-428d-88a8-3c67a2e4a3a5", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: []
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
    armTenants: {
        scopes: ['https://management.azure.com/user_impersonation'],
    },
    armBlobStorage: {
        scopes: ['https://storage.azure.com/user_impersonation'],
    },
    dotNetApi: {
        scopes: ['api://0989d77c-2895-4415-9712-d7a22183f210/Invoke.API'],
    }
};

/**
 * Add your Storage account name here and if you did create a Storage account see: 
 * https://docs.microsoft.com/en-us/azure/storage/common/storage-account-create?tabs=azure-portal
 * 
 */
export const storageInformation = {
    accountName: 'mosaicstg', // storage account name
    containerName: 'ms-identity-react-c2s2', // storage container name
};


